import React from 'react'

import type { GridFilterDefinition } from '../types'

import { BooleanFilter } from './BooleanFilter'
import { DateRangeFilter } from './DateRangeFilter'
import { MultiSelectFilter } from './MultiSelectFilter'
import { NumberFilter } from './NumberFilter'
import { SelectFilter } from './SelectFilter'
import { TextFilter } from './TextFilter'

type Props = {
	definition: GridFilterDefinition
	value: unknown
	onChange: (value: unknown) => void
}

export const renderFilter = ({ definition, value, onChange }: Props): React.ReactElement => {
	switch (definition.kind) {
		case 'text':
			return (
				<TextFilter
					value={typeof value === 'string' ? value : ''}
					placeholder={definition.placeholder}
					onChange={onChange}
				/>
			)
		case 'select':
			return (
				<SelectFilter
					value={typeof value === 'string' ? value : ''}
					options={definition.options}
					placeholder={definition.placeholder}
					onChange={onChange}
				/>
			)
		case 'multiselect':
			return (
				<MultiSelectFilter
					value={Array.isArray(value) ? (value as string[]) : []}
					options={definition.options}
					placeholder={definition.placeholder}
					onChange={onChange}
				/>
			)
		case 'daterange': {
			const range = (value as { from?: string; to?: string }) ?? {}
			return (
				<DateRangeFilter
					value={{ from: range.from ?? '', to: range.to ?? '' }}
					placeholder={definition.placeholder}
					onChange={onChange}
				/>
			)
		}
		case 'number':
			return (
				<NumberFilter
					value={typeof value === 'string' ? value : ''}
					placeholder={definition.placeholder}
					onChange={onChange}
				/>
			)
		case 'boolean':
			return (
				<BooleanFilter
					value={value === 'true' || value === 'false' ? value : ''}
					placeholder={definition.placeholder}
					onChange={(v) => onChange(v === '' ? null : v)}
				/>
			)
	}
}
